import angular from 'angular';
import SentMessageDetailsComponent from './sent-message-details-component';

export default angular.module('sent-message-details', []).component('sentMessageDetails', new SentMessageDetailsComponent());



// WEBPACK FOOTER //
// ./src/modules/message/components/sent-message-details/sent-message-details-module.js